import { cssVar as o, defineStyle as a, defineStyleConfig as i } from "@chakra-ui/react";
const r = o("popper-arrow-bg"), e = a({
  borderRadius: "lg",
  paddingY: 2,
  paddingX: 4,
  boxShadow: "100",
  backgroundColor: "primary.700",
  maxWidth: "240px",
  color: "white",
  fontSize: "sm",
  [r.variable]: "colors.primary.700",
  _dark: {
    color: "primary.700",
    backgroundColor: "white",
    [r.variable]: "white"
  }
}), t = i({
  baseStyle: e,
  variants: {
    default: {},
    light: {
      _dark: {
        backgroundColor: "primary.700",
        color: "white",
        [r.variable]: "colors.primary.700"
      }
    },
    dark: {
      color: "primary.700",
      backgroundColor: "white",
      [r.variable]: "white",
      _light: {
        color: "primary.700",
        backgroundColor: "white",
        [r.variable]: "white"
      }
    }
  },
  defaultProps: {
    variant: "default"
  }
});
export {
  t as Tooltip
};
//# sourceMappingURL=Tooltip.es.js.map
